import type { Application } from "@hotwired/stimulus";

export function getApplication(): Application {
  const application = window.planima.stimulusApplication;
  if (!application) {
    throw new Error(
      "Stimulus application is not initialized on window.planima"
    );
  }

  return application;
}
